import { trackError, ValidationError } from '#api/errors.ts';
import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { AuthLayout } from '#components/patterns/layouts/auth/AuthLayout.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';
import { useAuth } from '#global/context/auth/useAuth.tsx';

type Props = {
  error?: ValidationError | Error;
};

export function SSOError({ error }: Props) {
  const { oidcLoginURL } = useAuth();

  let message = 'There was a problem logging in. Please try again.';
  if (error instanceof ValidationError && error.errors[0]?.message) {
    message = error.errors[0].message;
  } else if (error) {
    trackError(error);
  }

  return (
    <AuthLayout>
      <CenteredLayout className="pad-0" preventNotifications={true}>
        <div role="alert">
          <h2 className="h3 mb-8">Could not authenticate</h2>
          <p className="p mb-24">{message}</p>
          <LinkButton to={oidcLoginURL ?? '/'} variant="secondary">
            Try again
          </LinkButton>
        </div>
      </CenteredLayout>
    </AuthLayout>
  );
}
